export default __webpack_public_path__ + "static/media/checkmark-circle-outline.75d9302e.svg";